<ng-template #basicInfo>
    @if (nameDateGroup) {
        <form [formGroup]="nameDateGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'advEffWizard.basicInfoHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                @if (standingData) {
                    <div class="col-12 pb-5 text-start" [hidden]="isSummary">
                        <div class="form-group">
                            <label>{{ 'advEffWizard.selectOriginLabel' | t }}</label>
                            <ng-select
                                data-uiid="wizard-testplan-origin-select"
                                [(ngModel)]="effectivenessOrigin"
                                [ngModelOptions]="{ standalone: true }"
                                bindValue="ID"
                                bindLabel="Name"
                                [clearable]="false"
                                (change)="originChanged()"
                                [items]="[
                                    { ID: 1, Name: 'New Test Plan' },
                                    { ID: 2, Name: 'Copy from existing Test Plan' },
                                    { ID: 3, Name: 'Copy from catalogue' },
                                ]"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            @switch (effectivenessOrigin) {
                                @case (originTypes.existing) {
                                    <label>{{ 'advEffWizard.selectExistingLabel' | t }}</label>
                                    <ng-select
                                        data-uiid="wizard-testplan-to-copy-select"
                                        [(ngModel)]="originExistingID"
                                        [ngModelOptions]="{ standalone: true }"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        [items]="existingTestPlans | async"
                                        [loading]="!existingTestPlans && !originLoading"
                                        [clearable]="false"
                                        (change)="loadExistingEffectiveness()"
                                    >
                                    </ng-select>
                                }
                                @case (originTypes.catalogue) {
                                    <label>{{ 'advEffWizard.selectCatalogueLabel' | t }}</label>
                                    <ng-select
                                        data-uiid="wizard-catalogue-to-copy-select"
                                        [(ngModel)]="originCatalogueID"
                                        [ngModelOptions]="{ standalone: true }"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        [items]="catalogues | async"
                                        [loading]="!catalogues && !originLoading"
                                        [clearable]="false"
                                        (change)="loadCatalogue()"
                                    >
                                    </ng-select>
                                }
                            }
                        </div>
                    </div>
                    <div class="col left-block">
                        <div class="form-group">
                            <label>{{ 'advEffWizard.nameTestPlanLabel' | t }}</label>
                            <cerrix-textfield
                                dataUiid="wizard-testplan-name-textfield"
                                [errorLabel]="'advEffWizard.nameTestPlanErrorLabel' | t"
                                formControlName="name"
                            ></cerrix-textfield>
                        </div>
                        <div class="form-group">
                            <label>{{ 'advEffWizard.testPeriodLabel' | t }}</label>
                            <ng-select
                                data-uiid="wizard-test-period-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="testPeriod"
                                [items]="standingData.TestPeriodData"
                                [loading]="!standingData.TestPeriodData"
                            >
                            </ng-select>
                        </div>
                    </div>
                    <div class="col right-block">
                        <div class="form-group">
                            <label>{{ 'advEffWizard.startDateLabel' | t }}</label>
                            <date-input
                                data-uiid="wizard-start-date-dateinput"
                                formControlName="startDate"
                            ></date-input>
                            @if (nameDateGroup.controls.startDate.errors) {
                                <div class="red" data-uiid="wizard-start-date-error-div">
                                    @if (nameDateGroup.controls.startDate.errors.periodDates) {
                                        <p>
                                            {{
                                                nameDateGroup.controls.startDate.errors.periodDates
                                            }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label>{{ 'advEffWizard.endDateLabel' | t }}</label>
                            <date-input
                                data-uiid="wizard-end-date-dateinput"
                                formControlName="endDate"
                            ></date-input>
                            @if (nameDateGroup.controls.endDate.errors) {
                                <div class="red" data-uiid="wizard-end-date-error-div">
                                    @if (
                                        nameDateGroup.controls.endDate.errors.startDateAfterEndDate
                                    ) {
                                        <p>
                                            {{
                                                nameDateGroup.controls.endDate.errors
                                                    .startDateAfterEndDate
                                            }}
                                        </p>
                                    }
                                    @if (nameDateGroup.controls.endDate.errors.periodDates) {
                                        <p>
                                            {{ nameDateGroup.controls.endDate.errors.periodDates }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #sampleGeneration>
    @if (sampleGenerationGroup) {
        <form [formGroup]="sampleGenerationGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'advEffWizard.sampleGenerationHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                @if (standingData) {
                    <div class="col">
                        <div class="form-group-inline">
                            <cerrix-checkbox
                                dataUiid="wizard-use-controlexecution-checkbox"
                                [label]="'advEffWizard.useControlExecutionLabel' | t"
                                formControlName="useControlExecution"
                            ></cerrix-checkbox>
                            <i
                                class="fas fa-info-circle ms-2"
                                [title]="'advEffWizard.useControlExecutionInfo' | t"
                            ></i>
                        </div>
                        <div class="form-group">
                            <label
                                >{{ 'advEffWizard.sampleGenerationMethodLabel' | t }}
                                <i
                                    class="fas fa-info-circle ms-2"
                                    [matTooltip]="'advEffWizard.sampleGenerationMethodTooltip' | t"
                                ></i
                            ></label>
                            <ng-select
                                data-uiid="wizard-sample-generation-method-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="sampleGenerationMethod"
                                [items]="standingData.SampleGenMethData"
                                [loading]="!standingData.SampleGenMethData"
                                (change)="setDisabledControls()"
                                [clearable]="false"
                            >
                            </ng-select>
                            @if (sampleGenerationGroup.controls.sampleGenerationMethod.errors) {
                                <div
                                    class="red txt-align-left"
                                    data-uiid="wizard-sample-method-error-div"
                                >
                                    @if (
                                        sampleGenerationGroup.controls.sampleGenerationMethod.errors
                                            .SampleMethod
                                    ) {
                                        <p>
                                            {{
                                                sampleGenerationGroup.controls
                                                    .sampleGenerationMethod.errors.SampleMethod
                                            }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label>{{ 'advEffWizard.reasonManualSampleLabel' | t }}</label>
                            <cerrix-textarea
                                dataUiid="wizard-reason-manual-sample-generation-textarea"
                                [errorLabel]="'advEffWizard.reasonManualSampleErrorLabel' | t"
                                formControlName="reasonManualSampleGeneration"
                            ></cerrix-textarea>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #personsInvolvedDueDates>
    @if (personsInvolvedGroup) {
        <form [formGroup]="personsInvolvedGroup">
            <div class="row header-row">
                <div class="col left-block">
                    <label>{{ 'advEffWizard.personsInvolvedHeader' | t }}</label>
                </div>
                <div class="col right-block">
                    <label>{{ 'advEffWizard.dueDatesHeader' | t }}</label>
                </div>
            </div>
            <div>
                @if (standingData) {
                    <div class="row centered-row">
                        <div class="col left-block">
                            <div class="form-group">
                                @if (showSourceDocumentUploader) {
                                    <label>{{ 'advEffWizard.sourceDocUploaderLabel' | t }}</label>
                                    <i
                                        class="fas fa-info-circle ms-2"
                                        [title]="'advEffWizard.sourceDocUploaderInfo' | t"
                                    ></i>
                                    <ng-select
                                        data-uiid="wizard-source-document-uploader-select"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        formControlName="sourceDocumentUploaders"
                                        [items]="standingData.SourceDocumentUploaderData"
                                        [loading]="!standingData.SourceDocumentUploaderData"
                                        [multiple]="true"
                                        [closeOnSelect]="false"
                                    >
                                    </ng-select>
                                } @else {
                                    <label>{{ 'advEffWizard.noSourceDocRequired' | t }}</label>
                                }
                            </div>
                        </div>
                        <div class="col right-block">
                            @if (showSourceDocumentUploader) {
                                <div class="form-group">
                                    <label>{{ 'advEffWizard.sourceDocDueDateLabel' | t }}</label>
                                    <date-input
                                        data-uiid="wizard-source-document-uploader-due-date-dateinput"
                                        formControlName="sourceDocumentDueDate"
                                    ></date-input>
                                    @if (
                                        personsInvolvedGroup.controls.sourceDocumentDueDate.errors
                                    ) {
                                        <div
                                            data-uiid="wizard-source-document-uploader-due-date-error-div"
                                            class="red"
                                        >
                                            @if (
                                                personsInvolvedGroup.controls.sourceDocumentDueDate
                                                    .errors.DueDate
                                            ) {
                                                <p>
                                                    {{
                                                        personsInvolvedGroup.controls
                                                            .sourceDocumentDueDate.errors.DueDate
                                                    }}
                                                </p>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row centered-row">
                        <div class="col left-block">
                            <div class="form-group">
                                <label>{{ 'advEffWizard.evidenceUploaderLabel' | t }}</label>
                                <ng-select
                                    data-uiid="wizard-evidence-uploader-select"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="evidenceUploaders"
                                    [items]="standingData.EvidenceUploaderData"
                                    [loading]="!standingData.EvidenceUploaderData"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    (change)="setSourceDocumentUploaderUsers()"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="col right-block">
                            <div class="form-group">
                                <label>{{ 'advEffWizard.evidenceDueDateLabel' | t }}</label>
                                <date-input
                                    data-uiid="wizard-evidence-uploader-due-date-dateinput"
                                    formControlName="evidenceDueDate"
                                ></date-input>
                                @if (personsInvolvedGroup.controls.evidenceDueDate.errors) {
                                    <div
                                        class="red"
                                        data-uiid="wizard-evidence-uploader-due-date-error-div"
                                    >
                                        @if (
                                            personsInvolvedGroup.controls.evidenceDueDate.errors
                                                .DueDate
                                        ) {
                                            <p>
                                                {{
                                                    personsInvolvedGroup.controls.evidenceDueDate
                                                        .errors.DueDate
                                                }}
                                            </p>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="row centered-row">
                        <div class="col left-block">
                            <div class="form-group">
                                <label>{{ 'advEffWizard.testerLabel' | t }}</label>
                                <ng-select
                                    data-uiid="wizard-tester-select"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="testers"
                                    [items]="standingData.TesterData"
                                    [loading]="!standingData.TesterData"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    (change)="setSourceDocumentUploaderUsers()"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="col right-block">
                            <div class="form-group">
                                <label>{{ 'advEffWizard.testerDueDateLabel' | t }}</label>
                                <date-input
                                    data-uiid="wizard-tester-due-date-dateinput"
                                    formControlName="testerDueDate"
                                ></date-input>
                                @if (personsInvolvedGroup.controls.testerDueDate.errors) {
                                    <div class="red" data-uiid="wizard-tester-due-date-error-div">
                                        @if (
                                            personsInvolvedGroup.controls.testerDueDate.errors
                                                .DueDate
                                        ) {
                                            <p>
                                                {{
                                                    personsInvolvedGroup.controls.testerDueDate
                                                        .errors.DueDate
                                                }}
                                            </p>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    @if (!reviewerRequiredApplicationSetting) {
                        <div class="row centered-row">
                            <div class="form-group">
                                <label>{{ 'advEffWizard.reviewStepLabel' | t }}
                                    <i
                                        class="fas fa-info-circle ms-2"
                                        [matTooltip]="'advEffWizard.reviewStepTooltip' | t"
                                    ></i
                                ></label>
                                <mat-slide-toggle
                                    data-uiid="wizard-review-step-toggle"
                                    name="reviewEnabled"
                                    formControlName="reviewEnabled"
                                    size="small"
                                    color="primary"
                                    class="ms-5"
                                >
                                </mat-slide-toggle>
                            </div>
                        </div>
                    }
                    <div class="row centered-row">
                        <div class="col left-block">
                            @if (showReviewers) {
                                <div class="form-group">
                                    <label>{{ 'advEffWizard.reviewerLabel' | t }}</label>
                                    <ng-select
                                        data-uiid="wizard-reviewers-select"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        formControlName="reviewers"
                                        [items]="standingData.ReviewerData"
                                        [loading]="!standingData.ReviewerData"
                                        [multiple]="true"
                                        [closeOnSelect]="false"
                                        (change)="setSourceDocumentUploaderUsers()"
                                    >
                                    </ng-select>
                                </div>
                            }
                        </div>
                        <div class="col right-block">
                            @if (showReviewers) {
                                <div class="form-group">
                                    <label>{{ 'advEffWizard.reviewerDueDateLabel' | t }}</label>
                                    <date-input
                                        data-uiid="wizard-reviewers-due-date-dateinput"
                                        formControlName="reviewerDueDate"
                                    ></date-input>
                                    @if (personsInvolvedGroup.controls.reviewerDueDate.errors) {
                                        <div
                                            class="red"
                                            data-uiid="wizard-reviewers-due-date-error-div"
                                        >
                                            @if (
                                                personsInvolvedGroup.controls.reviewerDueDate.errors
                                                    .DueDate
                                            ) {
                                                <p>
                                                    {{
                                                        personsInvolvedGroup.controls
                                                            .reviewerDueDate.errors.DueDate
                                                    }}
                                                </p>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #testInformation>
    @if (basicTestInfoGroup) {
        <form [formGroup]="basicTestInfoGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'advEffWizard.testInformationHeader' | t }}</label>
                </div>
            </div>
            <div class="row centered-row">
                @if (standingData) {
                    <div class="col left-block">                        
                        <div class="form-group">
                            <label>{{ 'advEffWizard.sourceDocUploadInstructionsLabel' | t }}</label>
                            <i
                                class="fas fa-info-circle ms-2"
                                [title]="'advEffWizard.sourceDocUploadInstructionsInfo' | t"
                            ></i>
                            <cerrix-textarea
                                dataUiid="wizard-source-document-upload-instructions-textarea"
                                [errorLabel]="'advEffWizard.sourceDocUploadInstructionsLabel' | t"
                                formControlName="sourceDocumentUploadInstructions"
                            ></cerrix-textarea>
                        </div>
                        <div class="form-group">
                            <label>{{ 'advEffWizard.evidenceUploadInstructionsLabel' | t }}</label>
                            <i
                                class="fas fa-info-circle ms-2"
                                [title]="'advEffWizard.evidenceUploadInstructionsInfo' | t"
                            ></i>
                            <cerrix-textarea
                                dataUiid="wizard-evidence-upload-instructions-textarea"
                                [errorLabel]="'advEffWizard.evidenceUploadInstructionsLabel' | t"
                                formControlName="evidenceUploadInstructions"
                            ></cerrix-textarea>
                        </div>                        
                        <div class="form-group">
                            <label>{{ 'advEffWizard.testInstructionsLabel' | t }}</label>
                            <cerrix-textarea
                                dataUiid="wizard-test-instructions-textarea"
                                [errorLabel]="'advEffWizard.testInstructionsLabel' | t"
                                formControlName="testInstructions"
                            ></cerrix-textarea>
                        </div>
                    </div>
                    <div class="col right-block">
                        <div class="form-group">
                            <label>{{ 'advEffWizard.linkedStandardLabel' | t }}</label>
                            <ng-select
                                data-uiid="wizard-linked-standard-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="linkedStandard"
                                [items]="standingData.LinkedStandardData"
                                [loading]="!standingData.LinkedStandardData"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label>{{ 'advEffWizard.qualityAspectsLabel' | t }}</label>
                            <ng-select
                                data-uiid="wizard-quality-aspects-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="qualityAspects"
                                [items]="standingData.QualityAspectData"
                                [loading]="!standingData.QualityAspectData"
                                [multiple]="true"
                                [closeOnSelect]="false"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label>{{ 'advEffWizard.testNormLabel' | t }}</label>
                            <cerrix-textarea
                                dataUiid="wizard-test-norm-textarea"
                                [errorLabel]="'advEffWizard.testNormLabel' | t"
                                formControlName="testNorm"
                            ></cerrix-textarea>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #testSteps>
    <div class="row header-row">
        <div class="col">
            <label>{{ 'advEffWizard.testStepsHeader' | t }}</label>
        </div>
    </div>

    @if (testStepConfig) {
        <generic-list-manager [config]="testStepConfig" #testStepManager></generic-list-manager>
    }
</ng-template>

<ng-template #summary>
    @if (model && !effectivenessGuid) {
        <div class="row header-row">
            <div class="col">
                <label>{{ 'advEffWizard.summaryHeader' | t }}</label>
            </div>
        </div>
        <div class="row centered-row">
            <div class="col">
                <cerrix-checkbox
                    dataUiid="wizard-save-as-catalogue-checkbox"
                    [label]="'advEffWizard.saveAsCatalogueLabel' | t"
                    [(ngModel)]="model.storeAsCatalogue"
                ></cerrix-checkbox>
                @if (model.storeAsCatalogue) {
                    <div class="form-group">
                        <label>{{ 'advEffWizard.catalogueNameLabel' | t }}</label>
                        <cerrix-textfield
                            dataUiid="wizard-save-as-catalogue-catalogue-name-textfield"
                            [errorLabel]="'advEffWizard.catalogueNameErrorLabel' | t"
                            [(ngModel)]="model.storeAsCatalogueName"
                        ></cerrix-textfield>
                    </div>
                }
            </div>
        </div>
    }
</ng-template>

@if (wizardConfig) {
    <cerrix-wizard
        [config]="wizardConfig"
        [templates]="[
            basicInfo,
            sampleGeneration,
            personsInvolvedDueDates,
            testInformation,
            testSteps,
        ]"
        [summaryTemplate]="summary"
        #wizard
    >
    </cerrix-wizard>
}
